import { zodSchemes } from '@approvalmax/utils';
import { DocumentType } from 'shared/data/walletsKyc/v1';
import { z } from 'zod';

import { messages } from './PersonIdDocument.messages';

const documentSchema = z.array(zodSchemes.sourceFileRecord).nonempty({ message: messages.documentRequired });

const baseSchema = z.object({
    documentType: zodSchemes.required.select.enum(DocumentType),
});

const frontSideSchema = baseSchema.extend({
    requireBack: z.literal(false),
    front: documentSchema,
});

const bothSidesSchema = baseSchema.extend({
    requireBack: z.literal(true),
    front: documentSchema,
    back: documentSchema,
});

export const documentsSchema = z.discriminatedUnion('requireBack', [bothSidesSchema, frontSideSchema]);

export const schema = z.object({
    person: z
        .object({
            personDocuments: documentsSchema,
        })
        .passthrough(),
});
